import * as React from "react";
import {Fragment, useEffect, useState} from "react";
import {Item, Rental} from "../types";
import {layout, PushButton, typography} from "@variocube/cube-ui";
import {DateTime} from "luxon";
import {useRegenerateItemAccessCode} from "../regenerateItemAccessCode";
import {useLocalization} from "../../i18n";
import {useItems} from "../hooks";

export interface RentalDetailProps {
    rental?: Rental;
    item?: Item;
    className?: string;
}

export function RentalDetail({rental, item, className}: RentalDetailProps) {
    const {t, language} = useLocalization();
    const send = useRegenerateItemAccessCode();
    const [openCode, setOpenCode] = useState(item?.openCode);
    const [accessCodeGenerated, setAccessCodeGenerated] = useState(item?.accessCodeGenerated);
    const items = useItems();


    useEffect(() =>   {
        let changedItem = items.find(x => x.uuid === item?.uuid);
        setOpenCode(changedItem?.openCode);
        setAccessCodeGenerated(DateTime.now().toISO());
        }, [items]);

    return (
        <div className={className}>
            <div className={typography.title}>{t("Rental")}</div>
            {rental && (
                <Fragment>
                    <div className={layout.marginYSmall}>
                        <div>{rental.borrower.name}</div>
                        <div>{rental.borrower.email}</div>
                        <div>{rental.borrower.phone}</div>
                    </div>
                    <div className={layout.marginYSmall}>
                        <div className={typography.caption}>{t("Timeframe")}</div>
                        <div>
                            {DateTime.fromISO(rental.from).setLocale(language).toLocaleString(DateTime.DATETIME_SHORT)}
                            {" - "}
                            {DateTime.fromISO(rental.until).setLocale(language).toLocaleString(DateTime.DATETIME_SHORT)}
                        </div>
                    </div>
                </Fragment>
            )}
            {!rental && (
                <React.Fragment>
                    <div>
                        {t("NoCurrentRental")}
                    </div>
                    {(item && item.openCode) &&
                        <div>
                            <div className={layout.marginYLarge}>
                                <div className={typography.title}>{t("ItemOpenCode")}</div>
                                <div>{openCode}</div>
                            </div>
                            {accessCodeGenerated &&
                                <div className={layout.marginYSmall}>
                                    <div className={typography.title}>{t("ItemCodeGenerated")}</div>
                                    <span>{DateTime.fromISO(accessCodeGenerated).setLocale(language).toLocaleString(DateTime.DATETIME_SHORT)}</span>
                                </div>
                            }
                            <div hidden>
                            {item && item?.uuid &&
                                <div className={layout.marginYLarge}>
                                    <PushButton
                                        onClick={() => send.submit(item?.uuid ?? ''  )}
                                        primary>
                                        {t("ItemCodeRegenerate")}
                                    </PushButton>
                                </div>
                            }
                            </div>
                        </div>
                    }
                </React.Fragment>
            )}
        </div>
    )
}